
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rentals/signup",
      function () {
        return require("private-next-pages/rentals/signup.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rentals/signup"])
      });
    }
  